export const NewsBadge = ({
  newsCounter,
  hasMoreNews,
}: {
  newsCounter: number;
  hasMoreNews: boolean;
}) => {
  return (
    <>
      {' '}
      <span className="project-tabs__counter">
        {hasMoreNews ? `${newsCounter}+` : newsCounter}
      </span>
    </>
  );
};
